<template>
  <div>
    <div v-if="underMantainance">
      <under-mantainance></under-mantainance>
    </div>
    <div v-else>
      <div v-if="signedIn">
        <v-app id="inspire" :class="{ watermark: isStaging }">
          <v-navigation-drawer v-model="drawer" app>
            <v-list
              dense
              v-for="(menu, i) in mainMenus
                .filter(x =>
                  featureFlags && featureFlags.connect5GSq
                    ? x.path !== '/service-qualification'
                    : x.path !== '/service-qualification-5g'
                )
                .filter(x => x.type !== 'submenu')
                .filter(x =>
                  !featureFlags.sog3732
                    ? x.group !== 'nbnDirect'
                    : x.path !== ''
                )
                .filter(x =>
                  !featureFlags.sog6010
                    ? x.group !== 'admin'
                    : x.path !== ''
                )
                .filter(x =>
                  !featureFlags.sog6155
                    ? x.path !== '/excluded-products'
                    : true
                )"
              :key="i"
              data-cy-menu-item
            >
              <v-list-item v-if="menu.type !== 'parent'" :to="menu.path">
                <v-list-item-icon>
                  <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-title style="margin-left: -20px">{{
                  menu.text
                }}</v-list-item-title>
              </v-list-item>

              <v-list-group v-else :prepend-icon="menu.icon" :value="true">
                <template v-slot:activator>
                  <v-list-item-title style="margin-left: -20px">{{
                    menu.text
                  }}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="(submenu, x) in mainMenus
                    .filter(x =>
                      featureFlags && featureFlags.connect5GSq
                        ? x.path !== '/service-qualification'
                        : x.path !== '/service-qualification-5g'
                    )
                    .filter(x => x.type === 'submenu' && x.group === menu.group)
                    .filter(
                      x =>
                        (!featureFlags.sog5391
                          ? x.path !== '/nbn-ticket-management'
                          : x.path !== '') &&
                        (!featureFlags.sog5611
                          ? x.path !== '/organisation-management'
                          : x.path !== '')
                    )
                    .filter(x =>
                      !featureFlags.sog5964
                        ? x.path !== '/migration-result'
                        : x.path !== ''
                    )
                    .filter(x =>
                      !featureFlags.sog5958 && x.path === '/audit-logs'
                        ? false
                        : true
                    )
                    .filter(x =>
                      x.path === '/nbn-order-correction' ? isSuperAdmin : true
                    )"
                  :key="x"
                  :to="submenu.path"
                >
                  <v-list-item-title class="pl-9">{{
                    submenu.text
                  }}</v-list-item-title>
                </v-list-item>
              </v-list-group>

              <!-- <v-list-item-group>
               TO DO: remove feature flag
              <v-list-item
                v-for="(menu, i) in mainMenus.filter((x) =>
                  featureFlags && featureFlags.connect5GSq
                    ? x.path !== '/service-qualification'
                    : x.path !== '/service-qualification-5g'
                )"
                :key="i"
                :to="menu.menu === 'Parent' ? '' : menu.path"
                data-cy-menu-item
              >
                <v-list-item-action class="mr-5">
                  <v-icon color="primary">{{ menu.icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ menu.text }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mr-5" v-if="menu.menu === 'Parent'">
                  <v-icon color="primary" right>{{ arrowIcon }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group> -->
            </v-list>
          </v-navigation-drawer>
          <v-app-bar app class="primary" :class="{ watermarksm: isStaging }">
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
              class="white--text"
            ></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text"
              ><v-img
                src="../public/2sg_logo.png"
                width="80"
                height="50"
                class="middle"
                alt="2SG Logo"
              ></v-img
              ><span class="middle ml-2">Connect</span></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-col class="text-center caption white--text">
              Viewing as: {{ impersonating.impersonateEmail }}
              <v-btn
                class="error ml-5"
                v-if="
                  impersonating.impersonateEmail != impersonating.loginEmail
                "
                @click="removeImpersonation"
                >Logout</v-btn
              >
            </v-col>

            <v-menu offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" color="#fff">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item-group>
                  <v-list-item disabled>
                    <v-list-item-content>
                      <v-list-item-title class="d-flex align-center">
                        <v-icon class="mr-1" color="primary"
                          >mdi-account-settings</v-icon
                        >My Account
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="isAdmin">
                    <v-list-item-title
                      class="d-flex align-center"
                      @click="showImpersonateTable = true"
                    >
                      <v-icon class="mr-1" color="primary">mdi-eye</v-icon>View
                      As
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex align-center"
                      @click="mgr.signOut"
                    >
                      <v-icon class="mr-1" color="primary">mdi-logout</v-icon
                      >Logout
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-app-bar>
          <v-main>
            <v-container fluid>
              <v-row
                class="red mt-n3 py-3 px-12"
                v-if="is_visible && hasAnnouncement"
              >
                <div class="text-center" style="width:100%;">
                  <p class="font-weight-bold white--text ma-0">
                    {{ activeAnnouncement }}
                  </p>
                </div>
                <v-btn icon @click="close_announcement" dark class="close-icon">
                  <v-icon size="x-small">mdi-close</v-icon>
                </v-btn>
              </v-row>
              <v-row>
                <v-col>
                  <router-view></router-view>
                </v-col>
              </v-row>
            </v-container>
          </v-main>
          <v-footer class="primary" app>
            <span class="white--text caption mt-1">
              &copy; {{ currentYear }}
            </span>
            <v-spacer></v-spacer>
            <span
              v-if="appVersion"
              class="grey--text text--lighten-1 caption mt-1"
              data-cy-app-version
            >
              {{ appVersion }}
            </span>
          </v-footer>

          <process-loader :isActive="isProcessingActive"></process-loader>
          <http-response
            :text="httpText"
            :color="httpColor"
            :isActive="httpIsActive"
          ></http-response>
          <impersonate-table
            :toggle="showImpersonateTable"
            @onImpersonateClose="showImpersonateTable = false"
          ></impersonate-table>
        </v-app>
      </div>
    </div>
  </div>
</template>

<script>
import Mgr from "@/services/SecurityService";
import ImpersonateTable from "@/components/common/impersonate-table";
import UnderMantainance from "@/views/UnderMantainance.vue";
import { appVersionLabel } from "@/utils/appVersion";
export default {
  name: "App",
  components: {
    ImpersonateTable,
    UnderMantainance
  },
  data: () => ({
    drawer: null,
    mgr: new Mgr(),
    signedIn: false,
    showImpersonateTable: false,
    showNoticeDialog: false,
    isOpen: false,
    is_visible: true,
    current_announcement: "",
    mainMenus: [
      {
        icon: "mdi-access-point-network",
        text: "NBN Direct",
        path: "/",
        type: "parent",
        group: "nbnDirect"
      },
      {
        icon: "mdi-access-point-network",
        text: "Active Services",
        path: "/nbn-active-orders",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-access-point-network",
        text: "Migration Result",
        path: "/migration-result",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-access-point-network",
        text: "5G Ordering",
        path: "/orders",
        type: "",
        group: ""
      },
      {
        icon: "mdi-access-point-network",
        text: "NBN Orders",
        path: "/nbn-orders",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-check-decagram",
        text: "Service Qualification",
        path: "/service-qualification",
        type: "",
        group: ""
      },
      // {
      //   icon: "mdi-check-decagram",
      //   text: "* Service Qualification",
      //   path: "/service-qualification-5g",
      //   type: "",
      //   group: ""
      // },
      {
        icon: "mdi-check-decagram",
        text: "NBN Service Qualification",
        path: "/service-qualification-nbn",
        type: "submenu",
        group: "nbnDirect"
      },
      //{
      //icon: "mdi-check-decagram",
      //text: "Order Qualification",
      //path: "/order-qualification",
      //},
      // {
      //   icon: "mdi-view-list",
      //   text: "Appointments",
      //   path: "/appointments",
      //   type: "",
      //   group: ""
      // },
      {
        icon: "mdi-view-list",
        text: "NBN Appointments",
        path: "/nbn-appointment-management",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-view-list",
        text: "Audit Logs",
        path: "/audit-logs",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-view-list",
        text: "NBN Tickets",
        path: "/nbn-ticket-management",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-view-list",
        text: "NBN Organisation Management",
        path: "/organisation-management",
        type: "submenu",
        group: "nbnDirect"
      },
      {
        icon: "mdi-archive-remove",
        text: "Excluded Products",
        path: "/excluded-products",
        type: "",
        group: ""
      },
      {
        icon: "mdi-account-box-outline",
        text: "Admin",
        path: "/",
        type: "parent",
        group: "admin"
      },
      {
        icon: "mdi-account-box-outline",
        text: "Banner Announcement",
        path: "/banner-announcement",
        type: "submenu",
        group: "admin"
      },
      {
        icon: "mdi-swap-horizontal",
        text: "CVC Migration",
        path: "/cvc-migration",
        type: "submenu",
        group: "admin"
      },
      {
        icon: "mdi-pencil-box-outline",
        text: "NBN Order Correction",
        path: "/nbn-order-correction",
        type: "submenu",
        group: "admin"
      }
    ]
  }),
  created() {
    let vm = this;
    vm.mgr
      .getSignedIn()
      .then(signIn => {
        vm.signedIn = signIn;
        vm.getAnnouncements();
        vm.getImpersonate();
        vm.checkUser().catch(() => {});
        vm.isImpersonatedAdmin();
      })
      .catch(() => {
        vm.markRolesResolved();
      })
      .finally(() => {
        setTimeout(() => {
          vm.setProcessInactive();
        }, 500);
      });

    vm.setFlags(vm.$ld.flags);
  },
  computed: {
    underMantainance() {
      let vm = this;
      return vm.featureFlags.sog3690;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    appVersion() {
      return appVersionLabel(
        process.env.APP_VERSION,
        process.env.ENVIRONMENT
      );
    },
    isStaging() {
      return (
        process.env.NODE_ENV == "staging" ||
        process.env.NODE_ENV == "development"
      );
    },
    activeAnnouncement() {
      let vm = this;
      let text = "";
      let active = vm.announcements.filter(x => x.isActive);
      if (active.length > 0) text = active[0].announcementText;
      else text = "No available announcement";
      return text;
    }
  },
  methods: {
    removeImpersonation() {
      let vm = this;

      vm.resetFeature();

      vm.removeImpersonate()
        .then(() => {})
        .finally(() => {
          vm.$router.go(0);
        });
    },
    close_announcement() {
      this.is_visible = false;
    }
  },
  watch: {
    "$ld.flags": function() {
      let vm = this;
      vm.mgr.getUser().then(data => {
        if (data == null) {
          vm.mgr.signIn();
        } else if (data.profile && data.profile != undefined) {
          let user = {
            key: data.profile.name,
            firstName: data.profile.given_name,
            email: data.profile.name
          };

          vm.$ld.identify({ newUser: user }, function() {
            vm.setFlags(vm.$ld.flags);
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.middle {
  display: inline-block;
  vertical-align: middle;
}
.watermark {
  background: url("https://vonex.com.au/vonex/projects/watermark-blck.png")
    repeat !important;
}
.watermarksm {
  background: url("https://vonex.com.au/vonex/projects/watermark-small.png")
    repeat !important;
}
.close-icon {
  position: absolute;
  z-index: 2;
  color: #e41e1e;
  top: 2px;
  right: 10px;
  cursor: pointer;
}
.close-icon span i {
  background-color: #2c2c2c;
  border-radius: 50%;
}
</style>
